// LEGACY (Mermaid): Mermaid-only custom page detection is a legacy compatibility
// special case for existing custom pages that contain Mermaid diagrams. New
// diagram experiences use presentation diagram pages instead.
// Tracked by T2-10286; revisit ~2027-06-01 to assess removal.
const MERMAID_ONLY_REGEX = /^\s*```mermaid\r?\n([\s\S]*?)\r?\n```\s*$/;

/**
 * If the entire content is a single mermaid code fence, returns the mermaid
 * code inside it. Otherwise returns null.
 */
export function extractMermaidCode(content: string): string | null {
  const match = MERMAID_ONLY_REGEX.exec(content);
  return match?.[1] ?? null;
}
